import { Controller } from "@hotwired/stimulus";

const remembers = {};

export default class extends Controller {
  static targets = ["item"];
  static classes = ["hidden"];
  static values = {
    hideClass: { type: Boolean, default: true },
    rememberKey: String,
  };

  connect() {
    this.element.classList.add("reveal");
    this.class = this.hasHiddenClass ? this.hiddenClass : "hidden";

    if (this.rememberKeyValue) {
      if (remembers[this.rememberKeyValue]) {
        this.element.classList.add("revealed");
        this.itemTargets.forEach((item) => {
          item.classList.remove(this.class);
        });
      }
    }
  }

  toggle() {
    const revealed = this.element.classList.toggle("revealed");
    if (this.rememberKeyValue) {
      remembers[this.rememberKeyValue] = revealed;
    }

    if (this.hideClassValue) {
      this.itemTargets.forEach((item) => {
        item.classList.toggle(this.class);
      });
    }
  }

  show() {
    this.element.classList.add("revealed");
    if (this.rememberKeyValue) {
      remembers[this.rememberKeyValue] = true;
    }

    if (this.hideClassValue) {
      this.itemTargets.forEach((item) => {
        item.classList.remove(this.class);
      });
    }
  }

  hide() {
    this.element.classList.remove("revealed");

    if (this.rememberKeyValue) {
      remembers[this.rememberKeyValue] = false;
    }

    if (this.hideClassValue) {
      this.itemTargets.forEach((item) => {
        item.classList.add(this.class);
      });
    }
  }
}
